import { Component, OnInit } from '@angular/core';
import { ComunicacionService } from '../_services/comunicacion.service';
import { MatDialog } from '@angular/material/dialog';
import { UrlResolverService } from '../_services/urlResolver.service';

export interface Noticia {
  estado: any;
  fechaHoraEstado: any;
  fechaPublicacion: string;
  idComunicacion: number;
  imagenValor: any;
  nombreImagen: string;
  texto: string;
  titulo: string;
  usuarioEstado: any;
}

@Component({
  selector: 'app-dialog-expandir-imagenes',
  templateUrl: './dialog-expandir-imagenes.component.html',
  styleUrls: ['./dialog-expandir-imagenes.component.css']
})

export class DialogExpandirImagenesComponent implements OnInit {

  files: string;
  IDAPLICACION;
  listaNoticiasTotal: Noticia[];
  noticiasCargadas: boolean = false;
  noticias: Noticia[];
  hayNoticias: boolean = false;
  intervalo = 10000;

  constructor(
    public comunicacionService: ComunicacionService,
    public urlResolver: UrlResolverService,
    private dialog: MatDialog,
  ) {
    this.IDAPLICACION = 32;
  }

  ngOnInit() {
    this.getUrlComunicacion();
    this.getNoticiasFraccionadas();
    // this.files = this.comunicacionService.getUrlComunicacion();
  }
  
  async getUrlComunicacion() {
      // console.log(x);
      // this.comunicacionUrl = x.mensaje;
      // this.comunicacionUrl = '/home/Repositorio_Digital/comunicacion/imagenes_noticias/desarrollo/';
      this.files = this.comunicacionService.getUrlComunicacion();

  }

  async getNoticiasFraccionadas() {
    await this.comunicacionService.getNoticiasFraccionadas(
      this.IDAPLICACION,
      0,
      10
    ).toPromise().then((res) => {
      // console.log(res)
      if (res.length !== 0) {
        this.noticias = res.elementos.filter(this.filtrarPorNull);
        //console.log(this.noticias)
        this.noticiasCargadas = true;
      } else {
        this.hayNoticias = false;
      }
    }, (error) => {
      console.log(error,"hika");
    });
  }

  filtrarPorNull(noticia: Noticia) {
    return noticia.nombreImagen != null && noticia.nombreImagen != 'null';
  }

  onItemChange($event: any): void {
    console.log('Carousel onItemChange', $event);
  }

  esGif(nombre: string): boolean {
  return nombre?.toLowerCase().endsWith('.gif');
}

activeIndex = 0;
onSlide(event: any) {
  const index = Number(event.current.replace('slide-', ''));
  this.activeIndex = index;

  const item = this.noticias[index];

  this.intervalo = this.esGif(item.nombreImagen) ? 20000 : 10000;
}

shouldLoad(i: number): boolean {
  const total = this.noticias.length;

  const prev = (this.activeIndex - 1 + total) % total;
  const next = (this.activeIndex + 1) % total;

  return i === this.activeIndex || i === prev || i === next;
}
}
